import { useMemo } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useLessonQuizMe, useLessonQuizMeVideoRequestParams } from './useLessonQuizMe.migrated';
import { isVideoAsset } from '../../tracks/tracksUtils';
export const useLessonQuizMeSection = ({
  lesson
}) => {
  var _lesson$content$filte;
  const {
    isNotLaptop
  } = useMediaQuery();
  const {
    allVideosHaveCaptions,
    loading: captionsLoading
  } = useLessonQuizMeVideoRequestParams({
    contents: lesson === null || lesson === void 0 ? void 0 : lesson.content
  });
  const {
    captionsExistMap,
    generateQuizLoading,
    generateQuizError,
    regenerate: regenerateQuiz,
    regenerateSingleVideoQuiz,
    retryQuizGeneration
  } = useLessonQuizMe({
    lesson
  });
  const lessonQuizProps = useMemo(() => ({
    captionsExistMap,
    generateQuizLoading,
    generateQuizError,
    regenerateQuiz,
    regenerateSingleVideoQuiz
  }), [captionsExistMap, generateQuizLoading, generateQuizError, regenerateQuiz, regenerateSingleVideoQuiz]);
  const videoCount = (_lesson$content$filte = lesson === null || lesson === void 0 ? void 0 : lesson.content.filter(isVideoAsset).length) !== null && _lesson$content$filte !== void 0 ? _lesson$content$filte : 0;
  const preAssessmentAvailable = isNotLaptop && !captionsLoading && allVideosHaveCaptions && videoCount > 1;
  return {
    lessonQuizProps,
    preAssessmentAvailable,
    retryQuizGeneration
  };
};